import * as actions from './umoUtilsActionTypes';
import piction, { emailUMOsViaLightbox as emailUMOsViaLightboxUtil, pushWorkspaceToDMZ, shareDMZPortal } from '../utils/piction';
import { SESSION_EXPIRED_MESSAGE } from '../constants/sessionStateTypes';
import { sessionExpired } from './session';
import _ from 'lodash';
import appConfig from '../appConfig';

export const emailUMOsViaLightboxRequest =
  (lightboxID, fromName, fromEmail, toEmail, message, isPortal) => ({
    type: actions.UMO_UTILS_EMAIL_REQUEST,
    lightboxID,
    fromName,
    fromEmail,
    toEmail,
    message,
    isPortal,
  });

export const emailUMOsViaLightboxSuccess =
  (lightboxID, fromName, fromEmail, toEmail, message) => ({
    type: actions.UMO_UTILS_EMAIL_SUCCESS,
    lightboxID,
    fromName,
    fromEmail,
    toEmail,
    message,
  });

export const emailUMOsViaLightboxFailure =
  (error, lightboxID, fromName, fromEmail, toEmail, message) => ({
    type: actions.UMO_UTILS_EMAIL_FAILURE,
    error,
    lightboxID,
    fromName,
    fromEmail,
    toEmail,
    message,
  });

export const emailUMOsViaLightbox = (lightboxID, fromName, fromEmail, toEmail, message, isPortal) =>
  function emailUMOsViaLightboxDispatch(dispatch) {
    dispatch(emailUMOsViaLightboxRequest(lightboxID, fromName, fromEmail, toEmail, message, isPortal));

    return emailUMOsViaLightboxUtil(lightboxID, fromName, fromEmail, toEmail, message, isPortal)
      .then((res) => {
        dispatch(emailUMOsViaLightboxSuccess(lightboxID, fromName, fromEmail, toEmail, message));
        return res;
      })
      .catch((error) => {
        if (error.message && error.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(error));
        } else {
          dispatch(
            emailUMOsViaLightboxFailure(error, lightboxID, fromName, fromEmail, toEmail, message)
          );
        }
        return error;
      });
  };

export const pushWorkspaceToDMZRequest = lightboxID => ({
  type: actions.UMO_UTILS_DMZ_PUSH_REQUEST,
  lightboxID,
});

export const pushWorkspaceToDMZSuccess = lightboxID => ({
  type: actions.UMO_UTILS_DMZ_PUSH_SUCCESS,
  lightboxID,
});

export const pushWorkspaceToDMZFailure = (error, lightboxID) => ({
  type: actions.UMO_UTILS_DMZ_PUSH_FAILURE,
  error,
  lightboxID,
});

export const workspacePushToDMZ = lightboxID =>
  function workspacePushToDMZDispatch(dispatch) {
    dispatch(pushWorkspaceToDMZRequest(lightboxID));
    return piction.request('MNG_PORTAL_DMZ_PUSH', { ACTION: 'PUSH_TO_DMZ', WORKSPACE: lightboxID })
      .then((res) => {
        if (res && res.a && res.a.RETURN_MESSAGE && _.isArray(res.a.RETURN_MESSAGE)) {
          if (res.a.RETURN_MESSAGE[0].$.z === 'ERROR') {
            dispatch(pushWorkspaceToDMZFailure(res.a.RETURN_MESSAGE[0].$.e, lightboxID));
            throw new Error(res.a.RETURN_MESSAGE[0].$.e);
          }
          if (res.a.RETURN_MESSAGE[0] === 'Email Sent' || res.a.RETURN_MESSAGE[0].$.z === 'WARNING') {
            dispatch(pushWorkspaceToDMZSuccess(lightboxID));
            return res;
          }
        } else if (res.a.SUCCESS) {
          dispatch(pushWorkspaceToDMZSuccess(lightboxID));
          return res;
        } else if (res.message && res.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(res));
          throw new Error(res);
        }
        dispatch(pushWorkspaceToDMZFailure(res.message, lightboxID));
        throw new Error('Invalid response');
      })
      .catch((error) => {
        if (error.message && error.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(error));
        } else {
          dispatch(pushWorkspaceToDMZFailure(error, lightboxID));
        }
        return error;
      });
  };

export const portalShareToDMZRequest =
  (lightboxID, fromName, fromEmail, toEmail, message, isPortal) => ({
    type: actions.UMO_UTILS_EMAIL_REQUEST,
    lightboxID,
    fromName,
    fromEmail,
    toEmail,
    message,
    isPortal,
  });

export const portalShareToDMZSuccess =
  (lightboxID, fromName, fromEmail, toEmail, message) => ({
    type: actions.UMO_UTILS_EMAIL_SUCCESS,
    lightboxID,
    fromName,
    fromEmail,
    toEmail,
    message,
  });

export const portalShareToDMZFailure =
  (error, lightboxID, fromName, fromEmail, toEmail, message) => ({
    type: actions.UMO_UTILS_EMAIL_FAILURE,
    error,
    lightboxID,
    fromName,
    fromEmail,
    toEmail,
    message,
  });

export const portalShareToDMZ = (lightboxID, fromName, fromEmail, toEmail, message, isPortal) =>
  function portalShareToDMZDispatch(dispatch) {
    dispatch(portalShareToDMZRequest(lightboxID, fromName, fromEmail, toEmail, message, isPortal));
    const callArgs = {
      ACTION: 'EMAIL',
      USERNAME: fromName,
      PASSWORD: toEmail,
      EMAIL_ADDRESS: toEmail,
      MESSAGE: message,
      WORKSPACE: lightboxID,
      TEMPLATE: 'KAUI2.Portal_Email',
    };
    if (appConfig.portalShareUsername) {
      callArgs.BASE_ACCOUNT_ON_USERNAME = appConfig.portalShareUsername;
    }
    return piction.request('MNG_PORTAL_DMZ_PUSH', callArgs)
      .then((res) => {
        dispatch(portalShareToDMZSuccess(lightboxID, fromName, fromEmail, toEmail, message));
        if (res && res.a && res.a.RETURN_MESSAGE && _.isArray(res.a.RETURN_MESSAGE)) {
          if (res.a.RETURN_MESSAGE[0] === 'Email Sent') {
            return res;
          }
          dispatch(portalShareToDMZFailure(
            res.a.RETURN_MESSAGE[0].$.e, lightboxID, fromName, fromEmail, toEmail, message));
          throw new Error(res.a.RETURN_MESSAGE[0].$.e);
        } else if (res.a.SUCCESS) {
          return res;
        } else {
          if (res.message && res.message.includes(SESSION_EXPIRED_MESSAGE)) {
            dispatch(sessionExpired(res));
            throw new Error(res);
          }
          dispatch(portalShareToDMZFailure(
            res.a.ERROR_MESSAGE[0], lightboxID, fromName, fromEmail, toEmail, message));
          throw new Error('Invalid response');
        }
      })
      .catch((error) => {
        if (error.message && error.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(error));
        } else {
          dispatch(portalShareToDMZFailure(
            error, lightboxID, fromName, fromEmail, toEmail, message));
        }
        return error;
      });
  };

export const emailUMOsViaLightboxDismiss = () => ({
  type: actions.UMO_UTILS_EMAIL_DISMISS,
});


export const getWorkspaceDownloadOptionsRequest = (workspaceID, requestPromise) => ({
  type: actions.WORKSPACE_DOWNLOAD_OPTIONS_REQUEST,
  workspaceID,
  requestPromise,
});

export const getWorkspaceDownloadOptionsSuccess = (workspaceID, downloadOptions) => ({
  type: actions.WORKSPACE_DOWNLOAD_OPTIONS_SUCCESS,
  workspaceID,
  downloadOptions,
});

export const getWorkspaceDownloadOptionsFailure = (workspaceID, err) => ({
  type: actions.WORKSPACE_DOWNLOAD_OPTIONS_FAILURE,
  workspaceID,
  err,
});

export const getWorkspaceDownloadOptions = workspaceID =>
  function getWSDownloadOptionsDispatch(dispatch) {
    const options = workspaceID ? { LIGHTBOX_ID: workspaceID } : {};
    const promise = piction.request('DOWNLOAD_RULE', options, null)
      .then((res) => {
        if (res && res.a && res.a.dr && _.isArray(res.a.dr)) {
          dispatch(getWorkspaceDownloadOptionsSuccess(workspaceID, res.a.dr[0].drw));
          return res;
        }
        throw new Error(res);
      })
      .catch((err) => {
        if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(err));
        } else {
          dispatch(getWorkspaceDownloadOptionsFailure(workspaceID, err));
        }
        return err;
      });

    dispatch(getWorkspaceDownloadOptionsRequest(workspaceID, promise));
    return promise;
  };



// WEBPACK FOOTER //
// ./src/js/actions/umoUtils.js